import Vue from 'vue'
import Router from 'vue-router'


const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  linkExactActiveClass: 'routerActive',

  routes: [
    {
      path: '/',
      // redirect: '/transfer'
    },
    {
      name: 'login',
      path: '/login',
      component: resolve => require(['@/views/login'], resolve),
    },
    {
      name: '401',
      path: '/401',
      component: resolve => require(['@/views/401'], resolve),
    },
    {
      // 中转页
      name: 'transfer',
      path: '/transfer',
      component: resolve => require(['@/views/transfer'], resolve)
    },
    {
      name: 'index',
      path: '/index',
      redirect: '/index/userNews/userNewsList',

      component: resolve => require(['@/views/index'], resolve),
      children: [
        {
          name: 'userNews',
          path: '/userNews',
          redirect: '/index/userNews/userNewsList',
          // 菜单侧边栏 主体
          meta: {
            title: '新闻列表'
          },
          component: resolve => require(['@/views/userNews'], resolve),
          children: [{
            // 菜单侧边栏 新闻列表

            name: 'userNewsList',
            path: '/index/userNews/userNewsList',
            component: resolve => require(['@/views/userNewsList'], resolve),

          }, {
            // 菜单侧边栏 新闻详情

            name: 'userNewsDetail',
            path: '/index/userNews/userNewsDetail',
            component: resolve => require(['@/views/userNewsDetail'], resolve),

          },]
        },
        {
          name: 'siderNews',
          path: '/siderNews',
          redirect: '/index/siderNews/siderNewsList',
          meta: {
            title: '新闻列表'
          },
          component: resolve => require(['@/views/siderNews'], resolve),
          children: [{
            name: 'siderNewsList',
            path: '/index/siderNews/siderNewsList',
            component: resolve => require(['@/views/userNewsList'], resolve),

          }, {

            name: 'siderNewsDetail',
            path: '/index/siderNews/siderNewsDetail',
            component: resolve => require(['@/views/userNewsDetail'], resolve),

          }
          ]
        },
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js